/**
 *
 * @param relay connection object
 * @returns an array of the nodes in the connection or an empty array
 * if your dang graphQL has null edges/nodes. This should avoid having to null/undefined
 * check this deeper - however, will hide errors in return data.
 * @TODO: do a better job checking, and ship errors up to sentry so we still see them.
 */

export const mapNodes = (
  connection?:
    | {
        readonly edges?:
          | ReadonlyArray<
              | {
                  readonly node?: any | null;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined
) => {
  const returnVal = connection?.edges?.map((e: any | null) => e!.node);
  return !!returnVal ? returnVal : [];
};
